import { LoginResponseDto } from '@/types/auth.ts'
import axios from 'axios'

const getLoggedInUserAPICall = async (): Promise<LoginResponseDto> => {
	return axios
		.request<LoginResponseDto>({
			url: `/api/employees/user`,
			method: 'GET',
		})
		.then(res => res.data)
}

export { getLoggedInUserAPICall }
